/**
 * Firebase configuration for C.SENSE web application
 * Supports both FCM web push and analytics
 */

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAQ4r45QPi_-0q0lU3HtWjYZL9ns55ux0U",
    authDomain: "csense-mobile.firebaseapp.com",
    projectId: "csense-mobile",
    storageBucket: "csense-mobile.firebasestorage.app",
    messagingSenderId: "444197973349",
    appId: "1:444197973349:web:fe1f11f41856a1eda2058c",
    measurementId: "G-TG8PSL3S6W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

// Web Push VAPID key (from your backend)
const VAPID_KEY = "BFTg597-v2UvqoJJjUb_r3nO1EgBljttfLo4ygpXIkyVbVEt6I3oM1aUSbMdGktMjBifxEHl0fNkSkljDs_byQQ";

/**
 * Request FCM registration token for web push notifications
 */
export const requestFCMToken = async (): Promise<string | null> => {
    try {
        const currentToken = await getToken(messaging, {
            vapidKey: VAPID_KEY,
        });

        if (currentToken) {
            console.log('✅ FCM registration token:', currentToken);
            return currentToken;
        } else {
            console.log('❌ No registration token available.');
            return null;
        }
    } catch (err) {
        console.error('❌ An error occurred while retrieving token:', err);
        return null;
    }
};

/**
 * Listen for foreground messages
 */
export const onForegroundMessage = (callback: (payload: any) => void) => {
    onMessage(messaging, (payload: any) => {
        console.log('📬 Foreground message received:', payload);
        callback(payload);
    });
};

/**
 * Register FCM token with C.SENSE backend
 */
export const registerFCMTokenWithBackend = async (token: string): Promise<boolean> => {
    try {
        const response = await fetch('/api/users/register-fcm-token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('csense_auth_token')}`
            },
            body: JSON.stringify({
                fcm_token: token,
                platform: 'web',
                device_name: `${navigator.platform} - ${navigator.userAgent.split(' ')[0]}`,
                browser: navigator.userAgent.split(' ')[0],
                os: navigator.platform
            })
        });

        if (response.ok) {
            console.log('✅ FCM token registered with backend');
            return true;
        } else {
            console.error('❌ Failed to register FCM token with backend');
            return false;
        }
    } catch (error) {
        console.error('❌ Error registering FCM token:', error);
        return false;
    }
};

/**
 * Complete FCM setup for a user
 */
export const setupFCMForUser = async (): Promise<boolean> => {
    try {
        // Request permission
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            console.warn('⚠️ Notification permission not granted');
            return false;
        }

        // Get FCM token
        const token = await requestFCMToken();
        if (!token) {
            console.error('❌ Failed to get FCM token');
            return false;
        }

        // Register with backend
        const registered = await registerFCMTokenWithBackend(token);
        if (!registered) {
            console.error('❌ Failed to register token with backend');
            return false;
        }

        console.log('🎉 FCM setup complete');
        return true;
    } catch (error) {
        console.error('❌ FCM setup failed:', error);
        return false;
    }
};

/**
 * Test FCM notification
 */
export const testFCMNotification = async (message: string = 'Test notification'): Promise<boolean> => {
    try {
        const response = await fetch('/api/notifications/test-fcm', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('csense_auth_token')}`
            },
            body: JSON.stringify({
                message: message,
                camera_name: 'Test Camera',
                type: 'test_notification'
            })
        });

        if (response.ok) {
            console.log('✅ Test FCM notification sent');
            return true;
        } else {
            console.error('❌ Failed to send test FCM notification');
            return false;
        }
    } catch (error) {
        console.error('❌ Error sending test FCM notification:', error);
        return false;
    }
};

export { app, analytics, messaging };
export default firebaseConfig;